<template>
  <div :class="nodata" :style="cstyle">
    <span style="vertical-align: 0px;margin-right: 10px;">
      <svg
        t="1599634792304"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="2406"
        width="26"
        height="26"
      >
        <path
          d="M265.6 411.904a52.8128 52.8128 0 1 0 105.6 0 52.8128 52.8128 0 0 0-105.6 0z m387.2 0a52.8128 52.8128 0 1 0 105.6 0 52.8128 52.8128 0 0 0-105.6 0zM512 19.2C239.872 19.2 19.2 239.872 19.2 512S239.872 1004.8 512 1004.8 1004.8 784.128 1004.8 512 784.128 19.2 512 19.2zM801.28 801.28a409.2416 409.2416 0 0 1-130.0992 87.808A405.0688 405.0688 0 0 1 512 921.1904 407.4496 407.4496 0 0 1 222.592 801.28 406.9376 406.9376 0 0 1 102.784 512 407.4496 407.4496 0 0 1 222.72 222.592 406.9376 406.9376 0 0 1 512 102.784 407.4496 407.4496 0 0 1 801.408 222.72a406.9376 406.9376 0 0 1 119.808 289.28 406.016 406.016 0 0 1-32.1024 159.3088A405.76 405.76 0 0 1 801.28 801.28zM512 535.1168c-94.0544 0-171.1616 74.0352-176 166.7584a8.7808 8.7808 0 0 0 8.8064 9.2416h52.9152c4.608 0 8.576-3.5072 8.9088-8.1408a105.728 105.728 0 0 1 210.7648 0c0.3072 4.608 4.2752 8.1408 8.8832 8.1408h52.9152a8.7808 8.7808 0 0 0 8.8064-9.216c-4.864-92.7488-81.9456-166.784-176-166.784z"
          p-id="2407"
          fill="#999999"
        />
      </svg>
    </span>
    <span style="vertical-align: 0px;">
      <slot>暂无数据</slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'noData',
  props: {
    cstyle: {
      type: Object,
      value: {}
    },
    nodata: {
      type: String,
      default: 'nodata'
    }
  }
}
</script>

<style scoped>
.nodata {
  padding: 50px 0;
  text-align: center;
  background-color: #fff;
  color: #999;
}
.nodataProduct {
  padding: 250px 0;
  text-align: center;
  background-color: #fff;
  color: #999;
}
.nodataPurchase {
  /* padding: 30px 0; */
  text-align: center;
  background-color: #fff;
  color: #999;
}
</style>
